import React from 'react';
import '../competencyList/competencyList.css';

export const CompetencyList = props => {
    const { competencies, limit } = props;
    if (!competencies || competencies.length === 0) return null;
    const sortString = competency => `${competency.area} - ${competency.name}`;
    const sortedCompetencies = competencies.filter(c => c !== null).sort((a, b) => (sortString(a) > sortString(b) ? 1 : -1));
    return (
        <div className="competency-list">
            {sortedCompetencies.map((c, i) => {
                if (i === limit) {
                    return (
                        <label key={i} className="label label-primary">
                            And {sortedCompetencies.length - limit} more....
                        </label>
                    );
                }
                if (limit && i > limit) return undefined;
                return (
                        <label key={i} className="label label-primary">
                            {`${c.area} - ${c.name}`}
                        </label>
                );
            })}
            <div className="clear" />
        </div>
    );
};

export default CompetencyList;
